import C from "./Config";

// Fetches all active medicines from the master list.
// Returns: { id, name, medicineId }[] or [] on error
export async function getAllMedicines() {
  try {
    const res = await fetch(
      C.getUrl() + "/additionalMedicationListMaster/getAllMedicines"
    );
    const resObj = await res.json();
    if (resObj && resObj.message) {
      try {
        const data = JSON.parse(resObj.message);
        const medicines = (Array.isArray(data) ? data : [])
          .map((d) => ({
            id: d.medicineId,
            name: d.medicineName,
            medicineId: d.medicineId,
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        return medicines;
      } catch (parseErr) {
        return [];
      }
    }
    return [];
  } catch (err) {
    console.error("Error fetching medicines:", err);
    return [];
  }
}

// Fetches all active dose values from the master list.
// Returns: { id, name, doseId }[] or [] on error
export async function getAllDoses() {
  try {
    const res = await fetch(
      C.getUrl() + "/patientOpVisit/getAllDoseMaster"
    );
    const resObj = await res.json();
    if (resObj && resObj.message) {
      try {
        const data = JSON.parse(resObj.message);
        const doses = (Array.isArray(data) ? data : [])
          .map((d) => ({
            id: d.doseId,
            name: d.doseName,
            doseId: d.doseId,
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        return doses;
      } catch (parseErr) {
        return [];
      }
    }
    return [];
  } catch (err) {
    console.error("Error fetching doses:", err);
    return [];
  }
}

// Fetches all active "when to take" timing values from the master list.
// Returns: { id, name, whenId }[] or [] on error
export async function getAllWhens() {
  try {
    const res = await fetch(
      C.getUrl() + "/patientOpVisit/getAllWhenMaster"
    );
    const resObj = await res.json();
    if (resObj && resObj.message) {
      try {
        const data = JSON.parse(resObj.message);
        const whens = (Array.isArray(data) ? data : [])
          .map((d) => ({
            id: d.whenId,
            name: d.whenName,
            whenId: d.whenId,
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        return whens;
      } catch (parseErr) {
        return [];
      }
    }
    return [];
  } catch (err) {
    console.error("Error fetching whens:", err);
    return [];
  }
}

// Creates a new medicine entry in the master list.
// Returns: the created medicine object on success, or null on error
export async function saveMedicine(medicineName) {
  try {
    const res = await fetch(
      C.getUrl() + "/additionalMedicationListMaster/saveMedicine",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          medicineName,
          activeInd: "Y",
          createdById: 1,
          updatedById: 1,
          creationDate: new Date().toISOString().split("T")[0],
          updatedDate: new Date().toISOString().split("T")[0],
        }),
      }
    );
    const result = await res.json();
    if (result && result.statusCode === 200) {
      // Return the newly created medicine; caller will refetch the full list
      // if needed. For now, just return the object with name populated.
      try {
        const data = JSON.parse(result.message);
        return {
          id: data.medicineId,
          name: data.medicineName,
          medicineId: data.medicineId,
        };
      } catch (e) {
        return { id: result.data?.medicineId, name: medicineName, medicineId: result.data?.medicineId };
      }
    }
    return null;
  } catch (err) {
    console.error("Error saving medicine:", err);
    return null;
  }
}

// Creates a new dose entry in the master list.
// Returns: the created dose object on success, or null on error
export async function saveDose(doseName) {
  try {
    const res = await fetch(
      C.getUrl() + "/patientOpVisit/saveDoseMaster",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          doseName,
          activeInd: "Y",
          createdById: 1,
          updatedById: 1,
          creationDate: new Date().toISOString().split("T")[0],
          updatedDate: new Date().toISOString().split("T")[0],
        }),
      }
    );
    const result = await res.json();
    if (result && result.statusCode === 200) {
      try {
        const data = JSON.parse(result.message);
        return {
          id: data.doseId,
          name: data.doseName,
          doseId: data.doseId,
        };
      } catch (e) {
        return { id: result.data?.doseId, name: doseName, doseId: result.data?.doseId };
      }
    }
    return null;
  } catch (err) {
    console.error("Error saving dose:", err);
    return null;
  }
}

// Creates a new "when to take" timing entry in the master list.
// Returns: the created when object on success, or null on error
export async function saveWhen(whenName) {
  try {
    const res = await fetch(
      C.getUrl() + "/patientOpVisit/saveWhenMaster",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          whenName,
          activeInd: "Y",
          createdById: 1,
          updatedById: 1,
          creationDate: new Date().toISOString().split("T")[0],
          updatedDate: new Date().toISOString().split("T")[0],
        }),
      }
    );
    const result = await res.json();
    if (result && result.statusCode === 200) {
      try {
        const data = JSON.parse(result.message);
        return {
          id: data.whenId,
          name: data.whenName,
          whenId: data.whenId,
        };
      } catch (e) {
        return { id: result.data?.whenId, name: whenName, whenId: result.data?.whenId };
      }
    }
    return null;
  } catch (err) {
    console.error("Error saving when:", err);
    return null;
  }
}
